module.exports = __webpack_public_path__ + "static/assets/da2a2aea342a24665755d32776fd1bd9.svg";